import {createStackNavigator} from '@react-navigation/stack';
import React from 'react';
import {FontService} from 'trpc-react-native-ui';
import I18n from '../lib/i18n';
import CheckDocuments from '../scenes/CheckDocuments';
import Contracts from '../scenes/Contracts';
import ExternalWebview from '../scenes/ExternalWebview';
import GetRioNumber from '../scenes/GetRioNumber';
import LineTermination from '../scenes/LineTermination';
import LostAndStolen from '../scenes/LostAndStolen';
import ManageLines from '../scenes/ManageLines';
import {
  PickLineForRioNumber,
  PickLineToSuspend,
  PickLineToTerminate,
} from '../scenes/PickLineToManage';
import SimReplacement from '../scenes/SimReplacement';
import theme from '../theme-config';

const Stack = createStackNavigator();

export const ConnectedStack = () => {
  return (
    <Stack.Navigator
      initialRouteName="manageLines"
      screenOptions={{
        headerMode: 'none',
        cardStyle: {
          backgroundColor: theme.backgroundColor,
        },
        headerBackTitleVisible: false,
        headerLeft: null,
        headerTitleAllowFontScaling: false,
        headerStyle: {
          backgroundColor: theme.headerBackgroundColor,
          borderBottomWidth: 0,
        },
        headerTintColor: theme.dashboardHeaderTextColor,
        headerTitleStyle: {
          ...FontService.getStyle(theme.fontFamily, 'bold'),
          fontSize: 16,
        },
        title: null,
      }}>
      <Stack.Screen
        name="manageLines"
        component={ManageLines}
        options={() => ({
          title: I18n.t('Dashboard.ManageLines.title'),
        })}
      />
      <Stack.Screen
        name="getRioNumber"
        component={GetRioNumber}
        options={() => ({
          title: I18n.t('Dashboard.GetRioNumber.title'),
        })}
      />
      <Stack.Screen
        name="lostAndStolen"
        component={LostAndStolen}
        options={() => ({
          title: I18n.t('Dashboard.LostAndStolen.title'),
        })}
      />
      <Stack.Screen
        name="pickLineForRioNumber"
        component={PickLineForRioNumber}
        options={() => ({
          title: I18n.t('Dashboard.GetRioNumber.title'),
        })}
      />
      <Stack.Screen
        name="pickLineToSuspend"
        component={PickLineToSuspend}
        options={() => ({title: I18n.t('Dashboard.LostAndStolen.title')})}
      />
      <Stack.Screen
        name="pickLineToTerminate"
        component={PickLineToTerminate}
        options={() => ({title: I18n.t('Dashboard.LineTermination.title')})}
      />
      <Stack.Screen
        name="lineTermination"
        component={LineTermination}
        options={() => ({title: I18n.t('Dashboard.LineTermination.title')})}
      />
      <Stack.Screen
        name="simReplacement"
        component={SimReplacement}
        options={() => ({
          title: I18n.t('Dashboard.SimReplacement.title'),
        })}
      />
      <Stack.Screen
        name="checkDocuments"
        component={CheckDocuments}
        options={({route}) => ({
          title: route.params?.subscriptionSerialNumber ?? '',
        })}
      />
      <Stack.Screen
        name="contracts"
        component={Contracts}
        options={() => ({
          title: I18n.t('Dashboard.Contracts.title'),
        })}
      />
      <Stack.Screen
        name="externalWebview"
        component={ExternalWebview}
        options={() => ({title: I18n.t('Dashboard.Menu.externalWebview')})}
      />
    </Stack.Navigator>
  );
};
